import { useEffect, useRef, useState } from "react"
import { ResponsiveImageFragment } from "../../types.graphql"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"

export const RotatingLogos = ({
  logos,
  itemsPerRotation = 2,
  className,
}: {
  logos: (ResponsiveImageFragment | null)[]
  itemsPerRotation?: number
  className?: string
}) => {
  const logoItems = logos?.filter(Boolean) || []
  const [current, setCurrent] = useState(0)
  const total = logoItems.length
  const rows = Math.ceil(total / itemsPerRotation)
  const timer = useRef<number | null>(null)

  useEffect(() => {
    timer.current = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % rows)
    }, 3000)
    return () => {
      if (timer.current) {
        clearInterval(timer.current)
      }
    }
  })

  return (
    <div className="relative w-full flex items-stretch">
      {Array.from({ length: rows }).map((_, rowIndex) => {
        const startIndex = (rowIndex * itemsPerRotation) % total
        const items = []
        for (let i = 0; i < itemsPerRotation; i++) {
          const index = startIndex + i
          if (logoItems[index]) {
            items.push(logoItems[index]!)
          }
        }
        return (
          <div
            key={rowIndex}
            className={cn(
              `absolute left-0 top-1/2 -mt-[calc(var(--spacing-9)/2)] flex items-center justify-center gap-2`,
              className,
            )}
          >
            {items.map((logo, index) => (
              <ResponsiveImage
                {...logo}
                key={index}
                className={cn("w-auto h-9 opacity-0 transition-opacity", current === rowIndex && "opacity-100")}
                style={{
                  transitionDelay: `${index * 150}ms`,
                }}
              />
            ))}
          </div>
        )
      })}
    </div>
  )
}
